module.exports = __webpack_public_path__ + "img/feature-01.0a58d09e.png";